module.exports = __webpack_public_path__ + "img/home-12.beb31a0b.webp";